import React from "react";
import { useSearch } from "../context/SearchContext";
import HeroImg from "../Components/Layouts/HeroImg";
import "./Prediction.scss";

const PredictionDetail = () => {
  const { searchResult } = useSearch();

  if (!searchResult) return <p>No data to show.</p>;

  return (
    <>
      <HeroImg heading="Disease Prediction" text="Home / Prediction" />
      <div className="result-container">
        <h2>Disease Predicted: {searchResult.predicted_disease}</h2>
        <p>
          <strong>Description:</strong> {searchResult.description}
        </p>
<div className="table-wrapper">
        <table className="result-table">
  <thead>
    <tr>
      <th>Precaution</th>
      <th>Diet</th>
      <th>Workout</th>
      <th>Medication</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      {/* Precautions */}
      <td>
        <ul>
          {searchResult.precautions?.flat().map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </td>

      {/* Diet */}
      <td>
        <ul>
          {searchResult.diet?.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </td>

      {/* Workout */}
      <td>
        <ul>
          {searchResult.workout?.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </td>

      {/* Medication */}
      <td>
        <ul>
          {searchResult.medications?.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </td>
    </tr>
  </tbody>
</table>

</div>
      </div>

      <div className="footer">
        <h4>For more information, please consult a healthcare professional.</h4>
        <p>
          **Disclaimer: Paltu is not a substitute for professional medical advice.
        </p>
      </div>
    </>
  );
};

export default PredictionDetail;
